module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDCAMAAABdlVDoAAAAQlBMVEUAlUMFlkOHvEekxUjX1EnXqj/ZljrbQSbbQybcJB8ElkPcJiCjxUfvmzrwnDsAlUOkxEelxUimxUjwnTvwnjv73kp/sZ1KAAAACXRSTlPU1enu+Pr6/v438mKrAAAAxklEQVR4Xr3NSXLCQADAQJEYiGz2JP//KncuU9QU6g8003bfy8CB66T19D/wtxEcEhwSHBIcEhwSHBIcEhwSHBIcEhwSHBIcEhzy/nEbHb8vhwSHBIcEhwSHBIcEhwSHBIcEhwSHBIcEhwSHBIcEhwSHzB+Xzclkvc8fEhwSHBIcEhwSHBIcEhwSHBIcEhwSHBIcEhwSHBIc8vZx3pxM1scHDgkOCQ4JDgkOCQ4JDgkOCQ4JDgkOCQ4JDgkOCQ75Wgb2P8dZT1wyfhXpA4FvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cg.png
// module id = wZcr
// module chunks = 0